<template>
    <div
        class="estate-card"
        v-if="!hidden"
        v-waypoint="{ active: true, callback: trackId, options: {} }"
        @mouseover="mouseOver(estate.id)"
        @mouseout="mouseOut(estate.id)"
    >
        <a
            :href="estate.detail_url"
            @click.prevent="onCardClick"
        >
            <my-carousel
                v-if="estate.images.length > 1 && carousel"
                ref="card_carousel"
                :per-page="1"
                :pagination-enabled="false"
                :navigation-enabled="true"
                :navigation-next-label="'<span></span>'"
                :navigation-prev-label="'<span></span>'"
                :min-swipe-distance="2"
                @navigation-click="onPageChange"
                @page-change="onPageChange"
            >
                <slide
                    v-for="(image, num_image) in shownImages"
                    :key="image.id"
                >
                    <div
                        v-if="num_image >= current_page - 1 && num_image <= current_page + 1"
                        class="estate-carousel-image crop-center"
                        v-lazy:background-image="imageUrl(image.url.gallery_media)"
                    >
                        <img
                            v-lazy="imageUrl(image.url.gallery_media)"
                            :alt="estate.title"
                            width="320"
                            height="320"
                        >
                    </div>
                    <div class="estate-card-counter"><masked-image src="/img/icons/images-white.svg"></masked-image> {{ num_image + 1}}/{{ estate.images.length }}</div>
                </slide>

                <slide>
                    <div class="carousel-cta">
                        <masked-image src="/img/icons/search.svg" width="24" height="24"/>

                        <span>{{ trans('labels.cta') }}</span>
                    </div>
                </slide>
            </my-carousel>

            <div
                v-else-if="estate.images.length"
                class="estate-carousel-image crop-center"
                v-lazy:background-image="imageUrl(estate.images[0].url.gallery_media)"
            >
                <img
                    v-lazy="imageUrl(estate.images[0].url.gallery_media)"
                    :alt="estate.title"
                >
            </div>

            <img
                v-else
                class="estate-carousel-image"
                src="/img/estate-placeholder.jpg"
                :alt="estate.title"
            >

            <div class="estate-badges">           

                <span v-if="estate.top" class="estate-badge star-color pl-2 ">
                    <span class="star"><masked-image src="/img/icons/ico_star.svg" /></span> {{ trans('labels.top') }}
                </span>

                <span v-if="estate.exclusive" class="estate-badge">
                    {{ trans('labels.exclusive') }}
                </span>

                <span v-if="estate.best_offer" class="estate-badge">
                    {{ trans('labels.best_offer') }}
                </span>

                <span v-if="estate.virtual_tour" class="estate-badge">
                    {{ trans('labels.virtual_tour') }}
                </span>
            </div>

            <div class="estate-card-box-data">
                <div v-if="estate.price_alternative" class="estate-card-current-price-euro">
                    <slot name="estate-price-euro">
                        <span v-html="estate.price_alternative"></span>
                    </slot>
                </div>
                <div class="estate-card-price">
                    <div v-if="estate.price" class="estate-card-current-price">
                        <slot name="estate-price">
                            <span v-html="estate.price"></span>
                        </slot>
                    </div>
                    <estate-discount :estate="estate" />

                    <estate-user-actions
                        v-if="showActions"
                        :show-save="showSave"
                        :show-hide="showHide"
                        :estate="estate"
                        :extLang="extLang"
                        @hide="hide(estate)"
                        @unsaved="unsaved(estate)"
                    />
                </div>

                <div class="estate-card-titles-container">
                    <div class="estate-card-titles">
                        <h3 class="estate-card-title">
                            <slot name="estate-title">
                                {{ estate.title | capitalize }}
                            </slot>
                        </h3>

                        <h4 v-if="estate.subtitle" class="estate-card-subtitle">
                            <slot name="estate-subtitle">
                                {{ estate.subtitle | capitalize }}
                            </slot>
                        </h4>
                    </div>

                    <!-- Descrizione predisposta per eventuali necessità SEO -->
                    <!-- <modal-opener
                        :name="'estate-description-' + estate.id"
                        :data="{ estate: estate }"
                    >
                        <a @click.prevent="toggleDescription" class="btn">
                            <img src="/img/icons/plus.svg" />
                        </a>
                    </modal-opener> -->
                </div>

                <estate-card-data :estate="estate" />
            </div>
        </a>

        <!-- Descrizione predisposta per eventuali necessità SEO -->
        <!-- <modal
            v-if="show_description"
            :name="'estate-description-' + estate.id"
            ref="description"
            extra-class="full-screen-modal description-modal"
            :title="estate.title"
            icon= "description.svg"
        >
            <template slot="body">
                <div v-html="estate.description"></div>
            </template>
        </modal> -->
    </div>
</template>

<script>
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import VueWaypoint from "vue-waypoint"

import { isNumber } from '../../helpers/numbers'

// Componenti predisposti per attivare descrizioni su listato in caso di necessità SEO
// import Modal from '../Modal
// import ModalOpener from '../ModalOpener'

import EstateCardData from './CardData'
import EstateDiscount from './Discount'
import EstateUserActions from './UserActions'
import MyCarousel from '../MyCarousel'
import MaskedImage from '../MaskedImage.vue'

export default {
    components: {
        'estate-card-data': EstateCardData,
        'estate-discount': EstateDiscount,
        'estate-user-actions': EstateUserActions,
        'my-carousel': MyCarousel,
        'masked-image': MaskedImage

        // Componenti predisposti per attivare descrizioni su listato in caso di necessità SEO
        // 'modal': Modal,
        // 'modal-opener': ModalOpener,
    },

    props: {
        estate: {
            type: Object,
            required: false,
        },

        showHide: {
            type: Boolean,
            default: true,
        },

        showSave: {
            type: Boolean,
            default: true,
        },

        extLang: {
            type: Object
        },

        highlight: {
            type: Boolean,
            default: false,
        },

        showActions: {
            type: Boolean,
            default: true,
        },

        carousel: {
            type: Boolean,
            default: true,
        },

        origin: {
            type: String
        },
    },

    data() {
        return {
            current_page: 0,
            hidden: false,
            prevent_card_click: false,
            show_description: false,
            tracked: false
        }
    },

    computed: {
        lang() {
            if(this.$root.lang == undefined)
                return this.extLang
            else
                return this.$root.lang.estate_card
        },

        shownImages() {
            return this.estate.images.slice(0, 4)
        },

    },

    mounted() {
        this.recentEstatesCookies()

        window.events.$on('prevent_card_click', () => {
            this.preventCardClick()
        })
    },

    methods: {
        recentEstatesCookies() {
            // --- Gestione cookie
            if (this.origin == 'index' && this.$root.hasMarketingCookies) {
                var recent = JSON.parse($cookies.get('recent_' + this.estate.ad_type))

                if (((recent) && (recent.length < 4)) || (!recent)) {
                    
                    if (recent) {
                        recent.push(this.estate.id)
                    } else {
                        recent = [this.estate.id]
                    }
                    var recent_add = recent.filter(function(item, pos) {
                        return recent.indexOf(item) == pos
                    })

                    $cookies.set('recent_' + this.estate.ad_type, JSON.stringify(recent_add.slice(0, 10)), '1y', '', '', true)
                }
            }
        },

        hide(estate) {
            this.hidden = true

            this.$emit('hide')
        },

        imageUrl(image) {
            return image ? image : '/img/estate-placeholder.jpg'
        },

        onPageChange(page) {
            this.preventCardClick()

            if(isNumber(page)) {
                this.current_page = page
            }
        },

        unsaved(estate) {
            this.$emit('unsaved')
        },

        trackId({ el, going, direction }) {
            if (window.trackLibrary) {
                if ((!this.tracked) && (going === this.$waypointMap.GOING_IN) && (this.estate.ad_type == 'estate')) {
                    setTimeout(() =>
                        window.trackLibrary.track('events.impressioneImmobile', {
                            immobile_id: this.estate.id,
                            agenzia_id: this.estate.agency.id,
                            tipoPagina : 'listato',
                            nazione: this.estate.country,
                            origine: (window.location.search.substr(1).split('&').indexOf('origine=newsletter') !== -1) ? 'newsletter' : 'portale'
                        })
                    , 100)
                    this.tracked = true
                }
            }
        },

        mouseOver: function(id) {
            if(this.highlight)
            {
                window.events.$emit('list.estate.highlight', {
                    feature_id: id,
                    highlight: true
                });
            }
        },

        mouseOut: function(estate_id) {
            if(this.highlight)
            {
                window.events.$emit('list.estate.highlight', {
                    feature_id: estate_id,
                    highlight: false
                });
            }
        },

        onCardClick() {
            this.$nextTick(() => {
                if(! this.prevent_card_click) {
                    // isLoading()
                    location.href = this.estate.detail_url
                }
                else {
                    this.prevent_card_click = false
                }
            })
        },

        preventCardClick() {
            this.prevent_card_click = true

            setTimeout(() => {
                this.prevent_card_click = false
            }, 100)
        },

        toggleDescription() {
            window.events.$emit('prevent_card_click')

            this.show_description = ! this.show_description
        },
    },
}
</script>